const React = require('react');

const Item = require('../common/Item.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

class CustomMeta extends React.Component {
    constructor(props) {
        super(props);

        this.handleTypeValue = this.handleTypeValue.bind(this);
    }

    handleTypeValue(id) {
        switch (id) {
            case 'Order':
                const componentData = this.props.componentData || {};
                if (componentData.index != undefined) {
                    return { value: `${componentData.index + 1}` };
                }
                break;
            default:
                return null;
        }
    }

    render() {
        return <Item.CustomMeta.Component customFirstLineFormat={true} onTypeValue={this.handleTypeValue} {...this.props} />;
    }
}
const TypeConfigCustomMeta = {
    panel: {
        includes: function () {
            return {
                draggable: true,
                expanded: true,
                label: 'Include / Order',
                options: [
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Order') >= 0; },
                        display: 'Order Number',
                        draggable: true,
                        fullWidth: true,
                        name: 'Order',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        display: 'Artist',
                        draggable: true,
                        fullWidth: true,
                        name: 'Artist',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        display: 'Title',
                        draggable: true,
                        fullWidth: true,
                        name: 'Title',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Edition') >= 0; },
                        display: 'Edition Info',
                        draggable: true,
                        fullWidth: true,
                        name: 'Edition',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Date') >= 0; },
                        display: 'Date',
                        draggable: true,
                        fullWidth: true,
                        name: 'Date',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Medium') >= 0; },
                        display: 'Medium',
                        draggable: true,
                        fullWidth: true,
                        name: 'Medium',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Dimensions') >= 0; },
                        display: 'Dimensions',
                        draggable: true,
                        fullWidth: true,
                        name: 'Dimensions',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('AlternateDimensions') >= 0; },
                        display: 'Alternate Dimensions',
                        draggable: true,
                        fullWidth: true,
                        name: 'AlternateDimensions',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Framed') >= 0; },
                        display: 'Framing',
                        draggable: true,
                        fullWidth: true,
                        name: 'Framed',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Number') >= 0; },
                        display: 'Inventory Number',
                        draggable: true,
                        fullWidth: true,
                        name: 'Number',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('SKU') >= 0; },
                        display: 'SKU',
                        draggable: true,
                        fullWidth: true,
                        name: 'SKU',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Location') >= 0; },
                        display: 'Location',
                        draggable: true,
                        fullWidth: true,
                        name: 'Location',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Price') >= 0; },
                        display: 'Price',
                        draggable: true,
                        fullWidth: true,
                        name: 'Price',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('PriceOverride') >= 0; },
                        display: 'Display Price',
                        draggable: true,
                        fullWidth: true,
                        name: 'PriceOverride',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        name: '_sort',
                        value: ['Order', 'Artist', 'Title', 'Edition', 'Date', 'Medium', 'Dimensions', 'AlternateDimensions', 'Framed', 'Number', 'SKU', 'Location', 'Price', 'PriceOverride'],
                        visible: function () { return false; }
                    },
                    {
                        name: '_export',
                        value: ['Order', 'Artist', 'Title', 'Edition', 'Date', 'Medium', 'Dimensions', 'AlternateDimensions', 'Framed', 'Number', 'SKU', 'Location', 'Price', 'PriceOverride'],
                        visible: function () { return false; }
                    }
                ]
            };
        },
        meta: function () {
            return {
                expanded: false,
                label: 'Item Detail Configuration',
                options: [
                    { display: 'Alternate Dimensions Display Properties', id: 'alternateDimensionsProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'AlternateDimensions', value: '[AlternateDimensions]' }),
                    { display: 'Artist Display Properties', id: 'artistProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Artist', value: '[Artist]' }, {}),
                    { display: 'Date Display Properties', id: 'dateProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Date', value: '[Date]' }, {}),
                    { display: 'Dimensions Display Properties', id: 'dimensionsProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Dimensions', value: '[Dimensions]' }),
                    { display: 'Display Price Properties', id: 'displayPriceProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'PriceOverride', value: '[DisplayPrice]' }, {}),
                    { display: 'Edition Info Display Properties', id: 'editionProps', type: 'header' },
                    {
                        display: 'Limited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber], [EditionCount]',
                        name: 'formatEditionLimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]/[EditionCount]',
                        visible: function (config) {
                            return config.Includes && config.Includes.Edition;
                        }
                    },
                    {
                        display: 'Unlimited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber]',
                        name: 'formatEditionUnlimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]',
                        visible: function (config) {
                            return config.Includes && config.Includes.Edition;
                        }
                    },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Edition', type: 'edition' }),
                    { display: 'Framing Display Properties', id: 'framingProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Framed', value: '[Framing]' }),
                    { display: 'Inventory Number Display Properties', id: 'numberProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ keywords: '[Number]', name: 'Number', value: 'Inventory #: [Number]' }),
                    { display: 'Location Display Properties', id: 'locationProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Location', value: '[Location]' }, {}),
                    { display: 'Medium Display Properties', id: 'mediumProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Medium', value: '[Medium]' }, {}),
                    { display: 'Order Number Display Properties', id: 'orderProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Order', value: '[Order]' }),
                    { display: 'Price Display Properties', id: 'priceProps', type: 'header' },
                    TypeConfig.options.currency({ display: 'First Item Currency Format', name: 'PriceFirst', visible: function (config) { return config.Includes && config.Includes.Price; } }),
                    ...Item.CustomMeta.TypeConfig.options.meta({ includeHelpText: false, name: 'Price', type: 'currency' }),
                    { display: 'SKU Display Properties', id: 'skuProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ keywords: '[SKU]', name: 'SKU', value: 'SKU: [SKU]' }),
                    { display: 'Title Display Properties', id: 'titleProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Title', value: '[Title]' }, {})
                ]
            };
        },
        style: Item.CustomMeta.TypeConfig.panel.style
    }
};

function Notes(props) {
    return <Item.StringMeta.Component {...props} name="Notes" />;
}
const TypeConfigNotes = {
    panel: {
        block: function () { return Item.StringMeta.TypeConfig.panel.block({}); },
        style: Item.StringMeta.TypeConfig.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Notes',
                        name: 'Notes',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Order(props) {
    if (!Utilities.Config.checkVisibility(props, 'Order')) {
        return null;
    }
    let formatProps = {}
    if (props.config && props.config.Config && props.config.Config.Format) {
        formatProps = props.config.Config.Format;
    }
    const componentData = props.componentData || {};
    let content;
    if (componentData.index != undefined) {
        content = `${componentData.index + 1}`;
        if (formatProps.format && formatProps.format.length > 0) {
            content = formatProps.format.replace('[Number]', content);
        }
    }
    return <Item.Meta {...props} value={content} />;
}
const TypeConfigOrder = {
    panel: {
        block: function () { return Item.StringMeta.TypeConfig.panel.block(); },
        format: function () {
            return {
                expanded: false,
                label: 'Advanced',
                options: [
                    {
                        display: 'Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [Number]',
                        name: 'format',
                        type: 'format',
                        value: '[Number].'
                    }
                ]
            };
        },
        style: Item.StringMeta.TypeConfig.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Order Number',
                        name: 'Order',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Price(props) {
    return <Item.Price.Component customFirstLineFormat={true} {...props} />;
}
const TypeConfigPrice = {
    panel: {
        ...Item.Price.TypeConfig.panel,
        format: function () { return TypeConfig.panel.currency({ customFirstLineFormat: true }); }
    }
};

function PrivateNotes(props) {
    return <Item.StringMeta.Component {...props} name="PrivateNotes" />;
}
const TypeConfigPrivateNotes = {
    panel: {
        block: function () { return Item.StringMeta.TypeConfig.panel.block({}); },
        style: Item.StringMeta.TypeConfig.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Private Notes',
                        name: 'PrivateNotes',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

module.exports = {
    ...Item,
    CustomMeta: {
        Component: CustomMeta,
        TypeConfig: TypeConfigCustomMeta
    },
    Notes: {
        Component: Notes,
        TypeConfig: TypeConfigNotes
    },
    Order: {
        Component: Order,
        TypeConfig: TypeConfigOrder
    },
    Price: {
        Component: Price,
        TypeConfig: TypeConfigPrice
    },
    PrivateNotes: {
        Component: PrivateNotes,
        TypeConfig: TypeConfigPrivateNotes
    }
};